import {request} from '@/utils/http';

let userCouponList = '/fronted/mem_coupon/list'
let couponcenter = '/fronted/coupon/center'
let getCoupon = '/fronted/mem_coupon/receive'

export function GET_USERCOUPONLIST(params){
  return request(userCouponList,'get',params)
}
export function POST_COUPONCENTER(params){
  return request(couponcenter,'post',params)
}
export function POST_GETCOUPON(params){
  return request(getCoupon,'post',params)
}




// WEBPACK FOOTER //
// ./src/api/coupon.api.js